<template>
	<!-- <div class="" v-if="showPrompt && $installer && $installer.canInstall && !$installer.hasInstalled"> -->
	<div class="install-app" v-if="showPrompt && $installer.canInstall">
		<div class="content">
			<div @click="showPrompt = false" class="btn" v-ripple>
				<i class="icon icon-close invert"></i>
			</div>
			<div class="px-2">
				<h2>LG vendedores</h2>
				<p class="m-0">Instale la aplicación en el teléfono para mayor comodidad.</p>
			</div>
			<div>
				<div class="btn btn-outline-light" v-ripple @click="$installer.prompt">Instalar</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'InstallApp',

	data() {
		return {
			showPrompt: false,
		}
	},
	watch: {
		$installer: {
			deep: true,
			handler() {
				if (this.$installer && this.$installer.canInstall && !this.$installer.hasInstalled) {
					this.installApp()
				}
			},
		},
	},
	computed: {
		...mapGetters(['isAuthenticated']),
	},
	methods: {
		installApp() {
			if (this.isAuthenticated) {
				this.showPrompt = true
			}
		},
	},
}
</script>

<style scoped>
.install-app {
	position: absolute;
	top: 64px;
	width: 100%;
}
.install-app .content {
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #fff;
	background-color: #ff4b6e;
	max-width: 480px;
	padding: 8px 12px;
	margin: auto;
}
.install-app h2 {
	font-size: 16px;
	font-weight: 600;
}
.install-app p {
	font-size: 14px;
	line-height: 16px;
}
.install-app .btn {
	color: #fff;
}
</style>
